// src/components/NewActType.js
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { createActType, getActType, updateActType, deleteActType } from "../api";

const NewActType = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const handleGoBack = () => navigate(-1);

  const { id_activity: routeId } = useParams();
  const isEdit = Boolean(routeId);

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));
  const id_c = company?.id_c;

  const [form, setForm] = useState({
    id_activity: "",
    oper_active: 1,       // 1 = Sí / activo, 0 = No / inactivo
    observations: "",
  });

  // Carga en modo edición
  useEffect(() => {
    const load = async () => {
      if (!isEdit || !id_c || !routeId) return;
      const data = await getActType(id_c, routeId);
      if (data) {
        setForm({
          id_activity: data.id_activity,
          oper_active: Number(data.oper_active) ? 1 : 0,
          observations: data.observations || "",
        });
      }
    };
    load();
  }, [isEdit, id_c, routeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // oper_active viene desde <select> como string "1" | "0"
    if (name === "oper_active") {
      setForm((s) => ({ ...s, oper_active: Number(value) }));
      return;
    }
    setForm((s) => ({ ...s, [name]: value }));
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!id_c) throw new Error("id_c no encontrado");

      if (isEdit) {
        await updateActType(id_c, form.id_activity, {
          oper_active: form.oper_active,
          observations: form.observations || null,
          id_user: user?.id_u,
        });
        alert(t("Registro actualizado"));
      } else {
        await createActType(id_c, {
          id_activity: form.id_activity.trim(),
          oper_active: form.oper_active,
          observations: form.observations || null,
          id_user: user?.id_u,
        });
        alert(t("Registro creado"));
      }
      handleGoBack();
    } catch (error) {
      console.error("❌ Error guardando Activity Type:", error);
      alert(t("Ocurrió un error al guardar"));
    }
  };

  const handleDelete = async () => {
    if (!isEdit) return;
    if (!window.confirm(t("¿Eliminar este registro?"))) return;
    try {
      await deleteActType(id_c, form.id_activity);
      alert(t("Registro eliminado"));
      handleGoBack();
    } catch (error) {
      console.error("❌ Error eliminando Activity Type:", error);
      alert(t("Ocurrió un error al eliminar"));
    }
  };

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label htmlFor="id_activity">{t("actType2") /* ID Activity */}</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    id="id_activity"
                    name="id_activity"
                    value={form.id_activity}
                    onChange={handleChange}
                    required
                    disabled={isEdit}  // igual que tu patrón cuando la PK no debe cambiar
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="oper_active">{t("actType3") /* Oper Active */}</label></td>
                <td>
                  <select
                    className="input1"
                    id="oper_active"
                    name="oper_active"
                    value={String(form.oper_active)}
                    onChange={handleChange}
                    required
                  >
                    <option value="1">{t("Sí")}</option>
                    <option value="0">{t("No")}</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td><label htmlFor="observations">{t("actType4") /* Observations */}</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="observations"
                    name="observations"
                    rows="3"
                    value={form.observations}
                    onChange={handleChange}
                    placeholder={t("Opcional")}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7">
            {t("prodList12") /* Guardar / Crear */}
          </button>
          <button type="button" className="button7" onClick={handleGoBack}>
            {t("prodList13") /* Cancelar / Volver */}
          </button>
          {isEdit && (
            <button type="button" className="button7" onClick={handleDelete} style={{ marginLeft: 8 }}>
              {t("Borrar")}
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default NewActType;
